export const getAmplifyAuthErrorCode = (error) => error?.name || error?.code;
